import React from 'react';
// import { Link } from 'react-router-dom';

import fb from '../../assets/footer/fb.svg';
import instagram from '../../assets/footer/instagram.svg';
import youtube from '../../assets/footer/youtube.svg';
import linkedin from '../../assets/footer/linkedin.svg';
import teacheron from '../../assets/footer/teacheron.svg';
import mail from '../../assets/footer/mail.svg';

import './Footer.css';

const Footer = () => {
    return (
        <footer>
            <div className="footer">
                <div className="footer-links">
                    <a href="https://www.youtube.com/channel/UCw4p3_6kZ0e-KmXWyub2TXQ?view_as=subscriber" title="Youtube"><img src={youtube} alt="youtube"/></a>
                    <a href="https://www.facebook.com/One-Rock-Visuals-Graphics-104998491437304/?view_public_for=104998491437304" title="Facebook"><img src={fb} style={{marginLeft: 20}} alt="fb"/></a>
                    <a href="https://www.instagram.com/onerock.vag/" title="Instagram"><img src={instagram} style={{marginLeft: 20}} alt="instagram"/></a>
                    <a href="https://www.linkedin.com/company/69680773/admin/" title="Linkedin"><img src={linkedin} style={{marginLeft: 20}} alt="linkedin"/></a>
                    <a href="https://www.teacheron.com/tutor-profile/1okO" title="Teacheron"><img src={teacheron} style={{marginLeft: 20}} alt="teacheron"/></a>
                    <a href="mailto: onerock.vag@gmail.com" title="onerock.vag@gmail.com"><img src={mail} style={{marginLeft: 20}} alt="mail "/></a>
                </div>
                {/* <Link className="footer-text footer-text-tc" to="/terms-and-conditions">Terms and Conditions</Link> */}
                <p className="footer-text">KEEP CREATING, <span style={{color:"#ffffff"}}>KEEP EXPLORING</span> !</p>
                {/* <a className="footer-developer-link" href="https://www.yashsalian.com">Developed by YASH SALIAN</a> */}
            </div>
        </footer>
    );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js